import { Link, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// import { Link as RouterLink } from 'gatsby';
import React from 'react';

import Icon from '@components/Icon/Icon';

import * as ROUTES from '@constants/routes';

import { useIsMobile } from '@hooks/useIsMobile';
import { useNavigate } from '@hooks/useNavigate';

export default function BreadcrumbLink({
  color,
  name,
  to,
}: {
  color: string;
  name?: string;
  to: string;
}) {
  const mobile = useIsMobile();
  const { navigateRoute } = useNavigate();
  const { palette } = useTheme();

  const handleClick = async () => {
    const toRoute = to.concat('/');
    if (toRoute === ROUTES.HEALTH_SCORE) {
      navigateRoute(ROUTES.DASHBOARD);
      return;
    }
    navigateRoute(to);
  };

  return (
    <Link
      /*
      component={RouterLink}
      to={to}
      */
      onClick={handleClick}
      underline="none"
      sx={{
        textTransform: 'capitalize',
        fontWeight: 400,
        color: {
          xs: color,
          sm: palette.info.main,
        },
        opacity: {
          xs: 0.7,
          sm: 1,
        },
        fontSize: {
          xs: '20px',
          sm: '16px',
        },
        '&:hover': {
          opacity: {
            xs: 1,
            sm: 0.8,
          },
        },
      }}
    >
      <Stack direction="row" alignItems="center">
        {mobile && (
          <Icon
            clickable
            color="primary.contrastText"
            name="chevron-down"
            rotation={90}
            style={{ marginRight: 2 }}
            type="far"
          />
        )}
        {name}
      </Stack>
    </Link>
  );
}
